import cloneDeep from 'lodash/cloneDeep';
import { SetPoints } from '../points.actions';
import { TPointsByWorkspace } from '../points.model';
import { preserveLoadedDetailFields } from './preserve-detail-fields';

export function setPoints(oldState: TPointsByWorkspace, action: SetPoints): TPointsByWorkspace {
  const state = cloneDeep(oldState);

  if (!state[action.payload.workspaceId]) {
    state[action.payload.workspaceId] = {};
  }

  state[action.payload.workspaceId].entities = preserveLoadedDetailFields(
    state[action.payload.workspaceId].entities,
    action.payload.points,
  );

  return state;
}
